import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'nprogress/nprogress.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { enableES5 } from 'immer';
import * as serviceWorker from 'src/serviceWorker';
import { SettingsProvider } from 'src/contexts/SettingsContext';
import App from 'src/App';
import { initActivityTracking, instrumentFetch, instrumentClicks, instrumentTyping } from './utilities/activityTracker';

enableES5();

initActivityTracking();
instrumentFetch();
instrumentClicks();
instrumentTyping();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <SettingsProvider>
      <App />
    </SettingsProvider>
  </React.StrictMode>,
);

serviceWorker.register();
